import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { Service, ServiceResponse, RefResponse } from '@/features/services/types';

export type UseServiceOptions = {
  businessId?: number;
  page?: number;
  perPage?: number;
  userId?: number[] | number;
  googlePlaceId?: string;
  parent?: number;
  childServices?: boolean;
  addons?: boolean;
  active?: boolean;
};
export const getServices = ({
  googlePlaceId,
  page,
  perPage,
  userId,
  parent,
  childServices,
  addons,
  active,
}: UseServiceOptions = {}): Promise<ServiceResponse> => {
  if (googlePlaceId) {
    return axios.get(`/business/locations/${googlePlaceId}/prefill/services`, {
      params: { page, perPage, userId, parent, childServices, addons, active },
    });
  }

  return axios.get(`/services/all?lastUpdated=true`, {
    params: { page, perPage, userId, parent, childServices, addons, active },
  });
};

type QueryFnType = typeof getServices;

export const useServices = ({ businessId, page, perPage }: UseServiceOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['services'],
    queryFn: () => getServices({ businessId, page, perPage }),
  });
};

export const useGetAllServices = ({
  businessId,
  page,
  perPage,
  googlePlaceId,
  childServices,
  addons,
}: UseServiceOptions = {}) => {
  const obj = {
    businessId: businessId,
    page: page,
    perPage: perPage,
    googlePlaceId,
    childServices,
    addons,
  };
  return useMutation({
    ...obj,
    mutationFn: getServices,
  });
};

type UseRefOptions = {
  businessId?: number;
};
export const getRefValues = ({ businessId }: UseRefOptions = {}): Promise<RefResponse> => {
  return axios.get(`/ref-values`);
};

type UseRefValueOptions = {
  config?: MutationConfig<typeof getRefValues>;
};

export const useRefValue = ({ config }: UseRefValueOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getRefValues,
  });
};
